import { apiClient } from "../api";

/**
 * Servicio de autenticación (login, registro, recuperar contraseña)
 */

export const login = async (correo, contraseña) => {
  const { data } = await apiClient.post("login", {
    Correo: correo,
    Contraseña: contraseña,
  });
  return data;
};

export const register = async (userData) => {
  const { data } = await apiClient.post("api/register", userData);
  return data;
};

export const recoverPassword = async (correo) => {
  const { data } = await apiClient.post("recoverPassword", {
    Correo: correo,
  });
  return data;
};
